import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-scroll", "data-scroll-sticky", "data-scroll-target"]
const _hoisted_2 = { class: "rel project-overview-main__left-col--inner" }
const _hoisted_3 = { class: "project-overview-main__left-col--text-wrapper" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "c-text-red uppercase fira" }

import { ref, watch } from 'vue';
import { useMenuStore } from '@/store/pinia/menu';
import func from '@/helpers/func';
import { downloadIcon, playIcon } from "@/components/UI/svgs"
import { handleResize } from '@/composables/resizeHandler';

// STORE


export default /*#__PURE__*/_defineComponent({
  props: {
    leftColData: {
        type: Object,
        required: true,
    },
    scrollHasFinished: {
        type: Boolean,
    },
    hasScrolled: {
        type: Boolean,
    }
},
  emits: ['isVideoOpen'],
  setup(__props, { emit }) {

const props = __props

const store = useMenuStore();

// EMITS



// PROPS



// REFS
const isMounted = ref(false);
const isMountedStepTwo = ref(false);


// COMPOSABLES
const { windowWidth } = handleResize();

// METHODS
const handleVideoPlayState = () => {
    emit('isVideoOpen', true);
}

// WATCH
watch(props, (ns) => {
    if (ns.hasScrolled) {
        isMounted.value = true;
        setTimeout(() => {
            isMountedStepTwo.value = true;

        }, 1200);
    }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["project-overview-main__left-col bg-navy flex column abs wc-lg", { 'scroll-has-finished': __props.scrollHasFinished }]),
    "data-scroll": _unref(windowWidth) >= 1200 ? true : false,
    "data-scroll-sticky": _unref(windowWidth) >= 1200 ? true : false,
    "data-scroll-target": _unref(windowWidth) >= 1200 ? '#projectOverviewFixedTarget' : null
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["lh-0 pointer mb-34 project-overview-main__left-col--play-icon", { 'is-mounted': isMounted.value, 'is-mounted-step-two': isMountedStepTwo.value }]),
          innerHTML: _unref(playIcon),
          onClick: handleVideoPlayState
        }, null, 10, _hoisted_4),
        _createElementVNode("h2", {
          class: _normalizeClass(["fira bold c-white project-overview-main__left-col--title uppercase", { 'is-mounted': isMounted.value }])
        }, _toDisplayString(__props.leftColData?.title), 3),
        _createElementVNode("h3", {
          class: _normalizeClass(["fira bold c-white project-overview-main__left-col--subtitle uppercase mb-34", { 'is-mounted': isMounted.value }])
        }, _toDisplayString(__props.leftColData?.sub_title[_unref(store).locale]), 3),
        _createElementVNode("div", {
          class: _normalizeClass(["project-overview-main__left-col--description mb-34 c-white", { 'is-mounted': isMounted.value }]),
          innerHTML: __props.leftColData?.teaser[_unref(store).locale]
        }, null, 10, _hoisted_5),
        _createElementVNode("h3", {
          class: _normalizeClass(["fira c-white project-overview-main__left-col--title uppercase mb-21", { 'is-mounted': isMounted.value }])
        }, _toDisplayString(__props.leftColData?.value_title[_unref(store).locale]), 3),
        _createElementVNode("h2", {
          class: _normalizeClass(["luxury subt-design c-white project-overview-main__left-col--value uppercase", { 'is-mounted': isMounted.value }])
        }, _toDisplayString(__props.leftColData?.value[_unref(store).locale]), 3),
        (__props.leftColData?.project_file[0]?.url && __props.leftColData?.project_file[1]?.url && __props.leftColData?.project_file[2]?.url)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _unref(store).locale === 'ge' ? __props.leftColData?.project_file[0]?.url : _unref(store).locale === 'en' ? __props.leftColData?.project_file[1]?.url : __props.leftColData?.project_file[2]?.url,
              target: "_blank",
              class: _normalizeClass(["project-overview-main__left-col--pdf pt-34 flex mt-34 pointer", { 'is-mounted': isMounted.value }])
            }, [
              _createElementVNode("div", {
                class: "lh-0",
                innerHTML: _unref(downloadIcon)
              }, null, 8, _hoisted_7),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(func).tr('Download Brochure')), 1)
            ], 10, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ])
  ], 10, _hoisted_1))
}
}

})